var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-icon",attrs:{"hidden":_vm.hideIcon}},[_c('router-link',{attrs:{"to":"/message"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fa-comments")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }